import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SubmissionSnapshotSmartComponent } from './submission-snapshot-smart/submission-snapshot-smart.component';
import { SubmissionSnapshotEditComponent } from './submission-snapshot-edit/submission-snapshot-edit.component';
import { SubmissionSnapshotDisplayComponent } from './submission-snapshot-display/submission-snapshot-display.component';
import { FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CollapsibleContainerModule } from '../collapsible-container/collapsible-container.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';


@NgModule({
  declarations: [
    SubmissionSnapshotSmartComponent,
    SubmissionSnapshotEditComponent,
    SubmissionSnapshotDisplayComponent
  ],
  imports: [
    CollapsibleContainerModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    NgxMaskDirective,
  ],
  exports: [SubmissionSnapshotSmartComponent,SubmissionSnapshotEditComponent],
  providers: [
    provideNgxMask(),
  ]
})
export class SubmissionSnapshotModule { }
